<template>

    <div>
        <div class="row  no-gutters pt-xl-4 mb-xl-6">
            <div class="col-xl-3 col-6 tab-test-bird order-xl-1 order-2">

            </div>
            <div class="col-xl-6 col-12 tab-test-title order-xl-2 order-1 text-center pt-xl-3 mt-xl-0 mt-4"
                 v-if="lesson">
                {{lesson.lesson}}
            </div>
            <div class="col-xl-3 col-6 tab-video-points test-line order-xl-3 order-3" v-if="points">
                <div class="zerno-points">
                    {{points}}
                </div>
            </div>
            <div class="col-xl-12 col-12 tab-video-notice order-xl-4 order-4 text-center mt-xl-n7 mt-n5 mb-xl-0 mb-3">
                <div class="tab-video-notice-1">{{ $t('test') }} {{$t('№')}}{{ test.pos }}
                    <span class="ml-2" v-if="testsCount > 0">({{test.pos}} {{$t('of')}} {{testsCount}})</span>
                </div>
            </div>

            <div class="col-12 order-10 text-center" v-if="showTestIntro && test">

                <h2 class="mt-7" v-if="test.test">{{ test.test }}</h2>
                <h2 class="mt-7" v-else>{{ $t('test') }} {{$t('№')}}{{ test.pos }}</h2>
                <h1 class="mb-5 mt-2" v-if="test.description">«{{ test.description }}»</h1>
                <button
                        class="btn btn-success btn-large btn-lg mb-9 btn-to-next-lesson"
                        @click="startTest">
                    <i class="ni ni-spaceship mr-2"></i>{{ $t('start_test') }} {{$t('№')}}{{ test.pos }}
                </button>

            </div>

            <div class="col-12 order-10" v-if="!showTestIntro && test">
                <div class="row justify-content-center mb-4">
                    <div class="col-auto display-1 shuffled-word">
                       {{ mainElement.shuffled }}
                    </div>
                </div>




                <div class="row">
                    <div v-if="result=='correct'" class="col-12 mb-4 text-center">
                        <img src="poliimg/excellent.png"
                             class="test-image"
                             style="width: 250px"
                        >
                    </div>
                    <div v-if="result=='hint'" class="col-12 mb-4">
                        <div class="text-center">
                            <img src="poliimg/oops.png"
                                class="test-image"
                                style="width: 250px"
                            >
                        </div>
                        <p class="text-center h2">Правильный ответ: {{ mainElement.word }}</p>
                    </div>
                    <div v-if="result=='wrong'" class="col-12 mb-4">
                        <div class="text-center">
                            <img src="poliimg/oops2.png"
                                class="test-image"
                                style="width: 250px"
                            >
                        </div>
                        <p class="text-center h3">Попробуй еще раз</p>
                    </div>
                    <div class="col-12 mb-4 justify-content-center d-flex">
                        <base-input alternative=""
                                    placeholder="Введи ответ"
                                    input-classes="border-2"
                                    v-model="answer"
                                    class="mx-auto"
                                    style="min-width: 250px;"
                        />
                    </div>
                    <div class="col-12 mb-4 justify-content-center d-flex">
                        <div>
                            <button
                                    class="btn btn-secondary"
                                    @click="next()">
                                    Ответить
                            </button>
                            <button
                                    class="btn btn-secondary"
                                    @click="donotknow()">
                                    Не знаю ответ
                            </button>
                        </div>
                    </div>
                </div>


            </div>


        </div>
        <div class="row mb-4 mt-1 justify-content-center no-gutters" v-if="!showTestIntro && test">
            <button
                    class="btn btn-info"
                    @click="skip"
            >
                {{ $t('omit_task') }} &rarr;
            </button>
        </div>
    </div>


</template>

<style>
    .v-chip__content {
        font-size: 40px;
        font-weight: 500;
    }
    @media (max-width: 1024px) {
      .shuffled-word {
        font-size: 25px;
      }
    }
</style>

<script>
    import Vue from 'vue'
    import api from '@/utils/api'

    export default {
        name: 'Test23',
        props: {
            idtest: {default: null},
            lesson: {type: Object, default: null},
            points: {default: null},
            testsCount: {default: null},
            showButtons: {type: Boolean, default: true},
        },
        data: () => ({
            test: {},
            testtasks: [],
            testelements: [],
            taskIdx: 0,
            mainElement: {},
            audio: new Audio(),
            answer: '',
            result: null,

            errorChord: 'https://www.poliglotiki.ru/images/pol-mp3/error_chord.mp3',
            okChord: 'https://www.poliglotiki.ru/images/pol-mp3/ok.mp3',
            showTestIntro: true,
        }),

        computed: {
            currentTask: function () {
                console.log('currentTask')
                return (this.taskIdx < this.testtasks.length) ? this.testtasks[this.taskIdx] : {}
            },
        },

        watch: {
            taskIdx: async function () {
                this.loadTask()
            },
        },

        async mounted() {
            api({url: '/tests/' + this.idtest}).then(resp => {
                this.test = resp.data
            })
            const response = await api({url: '/testtasks?sort=pos' + (this.idtest ? '&filter[idtest]=' + this.idtest : '')})
            this.testtasks = response.data
            this.loading = false
        },

        methods: {
            async startTest() {
                if (this.testtasks.length) {
                    if (this.test.audio) {
                        await this.play(this.test.audio)
                    }
                    this.showTestIntro = false
                    this.loadTask()
                }
            },
            async loadTask() {
                this.result = null
                this.answer = ''
                if (this.currentTask.idtesttask) {
                    const response = await api({
                        method: 'get',
                        url: '/testelements?filter[idtesttask]=' + this.currentTask.idtesttask
                    })
                    this.testelements = response.data
                    this.mainElement = this.testelements.length ? this.testelements[0] : {}
                    this.play(this.mainElement.audio)
                    Vue.set(this.mainElement, 'shuffled', this.shuffleFull(this.mainElement.word.toUpperCase().split('')).join(''))
                    // console.log(this.taskIdx, this.currentTask, this.mainElement)
                } else {
                    this.$emit('testComplete')
                }
            },
            getBy(propname, value, array) {
                for (let index = 0; index < array.length; index++) {
                    if (array[index][propname] === value) return array[index]
                }

                return {}
            },

            shuffle(a) {
                for (let i = a.length - 1; i > 0; i--) {
                    const j = Math.floor(Math.random() * (i + 1));
                    [a[i], a[j]] = [a[j], a[i]]
                }
                return a
            },

            shuffleFull(items) {
                const originalState = [...items]

                for (let i = 0; i < 1000; i++) {
                    items = this.shuffle(items)
                    let wrongPlace = (originalState.join('') === items.join(''))
                    if (!wrongPlace) {
                        console.log('Shuffle tryes: ' + i)
                        break
                    }
                }

                return items
            },

            play: function (path) {
                return new Promise((resolve) => {
                    if (path) {
                        this.audio.src = path
                        this.audio.play()
                        this.audio.onended = function () {
                            console.log('Звук закончился')
                            resolve()
                        }

                        this.audio.onerror = function () {
                            console.log('Звук error')
                            resolve()
                        }
                    } else {
                        resolve()
                    }
                })
            },

            donotknow() {
                this.result = 'hint'
            },

            skip: function () {
                this.$emit('wrongAnswer', {test: this.test.test, taskIdx: this.taskIdx, error: 'Пропущено'})
                this.taskIdx++
            },

            next: async function () {
                if (this.answer.toUpperCase() === this.mainElement.word.toUpperCase()) {
                    this.result = 'correct'
                    this.$emit('correctAnswer')
                    if (this.mainElement.audio) {
                        await this.play(this.mainElement.audio)
                    } else {
                        await this.play(this.okChord)
                    }

                    this.taskIdx++
                } else {
                    this.result = 'wrong'
                    await this.play(this.errorChord)
                }
            },
        },
    }
</script>
